import { Table } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { UserContactSearch } from 'interfaces/user-contact-search'

const TableHeader = ({ columnNames }: { columnNames: string[] }) => {
  return (
    <>
      {columnNames?.map((name) => (
        <th key={name} className="modern-table-header-cell">
          {name}
        </th>
      ))}
    </>
  )
}

export const userContactName = (userContact: Partial<UserContactSearch>) => {
  if (userContact?.contact_first_name || userContact?.contact_last_name) {
    return `${userContact?.contact_first_name} ${
      userContact?.contact_last_name ? userContact?.contact_last_name : ''
    }`.trim()
  }

  return ''
}

const TableBody = ({ userContacts }: { userContacts: UserContactSearch[] }) => {
  return (
    <>
      {userContacts.map((userContact, index) => {
        const fullName = userContactName(userContact)
        return (
          <tr
            key={`${userContact.contact_id}-${userContact.user_contact_id}`}
            className={
              index === 0 ? 'modern-table-first-row' : 'modern-table-row-border'
            }
          >
            <td className="modern-table-body-cell">{userContact.contact_id}</td>
            <td className="modern-table-body-cell">
              <img
                style={{ maxWidth: '90px' }}
                src={userContact.contact_image_url}
                alt={fullName}
              />
            </td>
            <td className="modern-table-body-cell">{fullName}</td>
            <td className="modern-table-body-cell">
              <Link
                to={`/contacts/${userContact.contact_id}`}
                className="btn btn-sm btn-success"
                style={{
                  fontSize: 'clamp(10px, 2vw, 12px)',
                  padding: '4px 8px',
                  textDecoration: 'none',
                  whiteSpace: 'nowrap',
                }}
              >
                Go to Contact
              </Link>
            </td>
          </tr>
        )
      })}
    </>
  )
}

const UserContactsTable = ({
  userContacts = [],
  isFetching,
}: {
  userContacts?: UserContactSearch[]
  isFetching?: boolean
}) => {
  return (
    <Table responsive variant="dark" className="modern-table">
      <thead>
        <tr className="modern-table-header-row">
          <TableHeader
            columnNames={['ID', 'Image', 'Full Name', 'Contact Page']}
          />
        </tr>
      </thead>
      <tbody>
        {isFetching ? (
          <tr className="modern-table-first-row">
            <td className="modern-table-body-cell">Searching</td>
          </tr>
        ) : (
          <TableBody userContacts={userContacts} />
        )}
      </tbody>
    </Table>
  )
}

export default UserContactsTable
